import { RECEIVABLES, PAYABLES } from '../constants/LedgerTypes';
import { isIntermodalShipmentType } from './shipment-types';

export const getUnprocessedItems = (shipment, ledgerType) => {
  return (shipment[ledgerType] || []).filter((adj) => !adj.processed);
};

export const getUnprocessedReceivables = (shipment) => {
  return getUnprocessedItems(shipment, RECEIVABLES);
};

export const getUnprocessedPayables = (shipment) => {
  return getUnprocessedItems(shipment, PAYABLES);
};

export const mapIsUnappliedAdjustment = (shipment) => (lineItem) =>
  isIntermodalShipmentType(shipment) && !lineItem.equipment;

export const isApproveDisabled = (charge) =>
  Boolean(charge?.approved) || Boolean(charge?.processed);

export const canShowEditAction = (charge, isFinance = false) =>
  isFinance && !charge?.processed && !charge?.accessorial_request_id;

export const canShowApproveAction = (charge) =>
  (charge?.type === 'carrier_cost' || charge?.category === 'base_cost') &&
  !charge?.parent_adjustment_id;

export const canShowDeleteAction = (
  charge,
  isFinance = false,
  isIntermodal = true,
) =>
  isFinance &&
  !charge?.processed &&
  (isIntermodal ? !charge?.accessorial_request_id : true);

export const isValidStatus = (status) => !!status && status !== 'NA';

export function getOutstandingTotal(shipment, ledgerType) {
  return getUnprocessedItems(shipment, ledgerType).reduce((total, item) => {
    return total + (item.value || 0);
  }, 0);
}
